import { render, staticRenderFns } from "./Typesetting.vue?vue&type=template&id=47f7424e&scoped=true&"
import script from "./Typesetting.vue?vue&type=script&lang=js&"
export * from "./Typesetting.vue?vue&type=script&lang=js&"
import style0 from "./Typesetting.vue?vue&type=style&index=0&id=47f7424e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f7424e",
  null
  
)

export default component.exports